import React from 'react';
import './dataviz.scss';

function Methodology() {
  return (
    <div>
        <div className='content' style={{ paddingTop:'60px' }}>
            <div className='content__text methodology' style={{ backgroundColor:'#F2E9E2', borderBottom:'1px solid #9F4400'}}>
            <h4>研究方法</h4>

            <p>歪脑统计了从1984年到2024年，夏季和冬季奥林匹克运动会中国代表团奥运冠军的数据，样本不包括残疾人奥林匹克运动会的相关信息。</p>

            <p>图一：根据公开数据整理，统计数据中不包括现职业“不详”和仍为“现役”的样本。</p>

            <p>图二：中国城市划分标准参照2024《第一财经》统计发布的“<a href='https://www.sohu.com/a/786838856_260141' target='_blank'>2024新一线城市魅力排行榜</a>”, 统计包含中国内地337个地级及以上城市，其它县级市及以下。统计数据中不包括现居地和家乡“不详”的样本，也不包括出生地在“海外”的样本。</p>

            <p>关于居住地跨跃程度的统计，歪脑将样本重新编码：“县级市及以下”为0，“五线城市”为“1”，同理以此递增， “香港与海外”为7。跨越程度为“现居地类型”减去“家乡城市类型”的编码数值。某个项目的平均跨越值为跨越程度除以该项目的退役奥运冠军总数。</p>

            <p>图三：统计数据中删除了仍为“现役”的样本。仅保留了项目中男女获金牌的数目。</p>

            <p>图四：统计数据中删除了冬季奥运会22个奥运冠军的样本，也删除了仍“现役”的样本。仅统计了夏季奥运会中已退役的奥运冠军的样本。</p>


            </div>

            <div className='content__text methodology' style={{ textAlign:'center', padding:'7.5% 0', color:'#9F4400', fontWeight:'400'}}>
                <h4>Credits</h4>
                <div className='credits'>
                    <div>数据编辑</div><div>Paul Wang</div>
                    <div>文字编辑</div><div>Rachel Chen</div>
                    <div>图片编辑</div><div>Shell Long</div>
                    <div>设计制作</div><div>Regina Li</div>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Methodology